import Vue from 'vue';

import Cookies from 'js-cookie';

import { enrolmentPrivateTypes as types } from '@/store/types';
import { memberRegistrationEndpointsTypes } from '@/http/endpoints/MemberRegistrationEndpoints';

// STATE
const cleanState = {
  enrolmentUUID: '',
  isInvite: false,
  recovering: true,
  isRescheduling: false,
  version: 1,
  samlV2: null,
};

const defaultState = () => ({
  ...cleanState,
});

// GETTERS
const _getters = {
  [types.getters.GET_ENROLMENT_UUID]: state => state.enrolmentUUID,
  [types.getters.IS_INVITE]: state => state.isInvite,
  [types.getters.IS_RECOVERING]: state => state.recovering,
  [types.getters.IS_RESCHEDULING]: state => state.isRescheduling,
  [types.getters.GET_VERSION]: state => state.version,
  [types.getters.GET_SAML_V2]: state => state.samlV2,
  [types.getters.GET_AMWELL]: state => state.amwell,
};

// MUTATIONS
const mutations = {
  [types.mutations.SET_ENROLMENT_UUID](state, enrolmentUUID) {
    state.enrolmentUUID = enrolmentUUID;
  },
  [types.mutations.SET_INVITE](state, isInvite) {
    state.isInvite = isInvite;
  },
  [types.mutations.SET_RECOVERING](state, recovering) {
    state.recovering = recovering;
  },
  [types.mutations.SET_RESCHEDULING](state, isRescheduling) {
    state.isRescheduling = isRescheduling;
  },
  [types.mutations.SET_VERSION](state, version) {
    state.version = version;
  },
  [types.mutations.SET_SAML_V2](state, saml) {
    state.samlV2 = saml;
  },
  [types.mutations.SET_AMWELL](state, amwell) {
    state.amwell = amwell;
  },
};

// ACTIONS
const actions = {
  async [types.actions.START_ENROLMENT]({ commit }, { clientRef, payload }) {
    const { data } = await Vue.$http(memberRegistrationEndpointsTypes.START_ENROLMENT, clientRef, { body: payload });

    commit(types.mutations.SET_ENROLMENT_UUID, data.uuid);
    return data;
  },

  async [types.actions.LOAD_SAML]({ commit }) {
    const samlCookie = Cookies.get('saml');
    if (samlCookie) {
      try {
        const decoded = Buffer.from(samlCookie, 'base64').toString('utf-8');
        const { enrollment_uuid: uuid } = JSON.parse(decoded);
        commit(types.mutations.SET_ENROLMENT_UUID, uuid);
        Cookies.remove('saml');
      } catch (e) {
        console.error('failed to parse saml cookie', e);
      }
    }
  },

  [types.actions.LOAD_SAML_V2]({ state, commit }) {
    if (state.samlV2) {
      return state.samlV2;
    }

    const samlCookie = Cookies.get('samlv2');
    if (samlCookie) {
      try {
        const decoded = Buffer.from(samlCookie, 'base64').toString('utf-8');
        const parsed = JSON.parse(decoded);
        commit(types.mutations.SET_SAML_V2, parsed);
        Cookies.remove('samlv2');
        return parsed;
      } catch (e) {
        console.error('failed to parse saml v2 cookie', e);
        return null;
      }
    }
    return null;
  },

  [types.actions.LOAD_AMWELL]({ state, commit }) {
    if (state.amwell) {
      return state.amwell;
    }

    const amwellCookie = Cookies.get('amwell');
    if (amwellCookie) {
      try {
        const decoded = Buffer.from(amwellCookie, 'base64').toString('utf-8');
        const parsed = JSON.parse(decoded);
        commit(types.mutations.SET_AMWELL, parsed);
        Cookies.remove('amwell');
        return parsed;
      } catch (error) {
        console.error('failed to parse amwell cookie', error);
        return null;
      }
    }
    return null;
  },

  async [types.actions.LOAD_SSO]({ commit }) {
    const ssoCookie = Cookies.get('sso');
    if (ssoCookie) {
      try {
        const decoded = Buffer.from(ssoCookie, 'base64').toString('utf-8');
        const { enrollment_uuid: uuid } = JSON.parse(decoded);
        commit(types.mutations.SET_ENROLMENT_UUID, uuid);
        Cookies.remove('sso');
      } catch (e) {
        console.error('failed to parse sso cookie', e);
      }
    }
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters: _getters,
  mutations,
  actions,
};
